
export const environment = {
    production: false,
    authApiUrl: 'https://dev.medapps.ai/user-management',
    apiURL: 'https://dev.medapps.ai/user-management',
    baseUrl: 'https://dev.medapps.ai',
    filesApiUrl: 'https://dev.medapps.ai/gcs',
    cdnUrl: 'https://dev.medapps.ai/gcs',
    recaptchaKey: '6Lf8wgEgAAAAAHly0j9e51Uzi6dZ5PvyqDw9O9PB',
    placesApiKey: 'AIzaSyBaKgb5XgCiSjaPg0p3-IRChjjCyE94LQY'
};
